// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScholarsAndPeers_scholars-and-peers__cQ1ZD {
  width: 100%;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw {
  width: 100%;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw .ScholarsAndPeers_top-result__O1szh {
  width: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw .ScholarsAndPeers_top-result--tabs__KMEwj {
  border-bottom: 1px solid var(--light-grey);
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw .ScholarsAndPeers_top-result__O1szh .ScholarsAndPeers_search-scholar-section__qhl\\+n {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw .ScholarsAndPeers_top-result__O1szh .ScholarsAndPeers_search-scholar-section__qhl\\+n .ScholarsAndPeers_clear-search-button__PNIvs {
  width: 90px;
  height: 35px;
  border-radius: 50px;
  color: var(--dark-grey);
  background: transparent;
  margin-left: 10px;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-landscape__uQXNw .ScholarsAndPeers_top-result__O1szh .ScholarsAndPeers_search-scholar-section__qhl\\+n .ScholarsAndPeers_clear-search-button__PNIvs:hover {
  background: var(--explore-color);
  color: white;
  cursor: pointer;
}
.ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-mobile__VpMMI {
  display: none;
}
@media only screen and (max-width: 480px) {
  .ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-mobile__VpMMI {
    display: flex;
    flex-direction: column;
  }
  .ScholarsAndPeers_scholars-and-peers__cQ1ZD .ScholarsAndPeers_tabs-mobile__VpMMI .ant-tabs-nav {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    border-radius: 10px !important;
    padding-left: 20px;
  }
  .ScholarsAndPeers_scholars-and-peers__cQ1ZD {
    width: 100%;
  }
}

.ScholarsAndPeers_shadow__4Rh-e {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/ScholarsAndPeers/ScholarsAndPeers.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,WAAA;AACJ;AACI;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACN;AACM;EACE,0CAAA;AACR;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AAvBV;AA0BQ;EACE,gCAAA;EACA,YAAA;EACA,eAAA;AAxBV;AAkCE;EACE,aAAA;AAhCJ;AAkCI;EAHF;IAII,aAAA;IACA,sBAAA;EA/BJ;EAiCI;IACE,0CAAA;IACA,8BAAA;IACA,kBAAA;EA/BN;EA9CF;IAmFI,WAAA;EAhCF;AAJF;;AAwCA;EACE,yCAAA;AAhCF","sourcesContent":[".scholars-and-peers {\n  width: 100%;\n\n  .tabs-landscape {\n    width: 100%;\n\n    .top-result {\n      width: 100%;\n      background: transparent;\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n\n      &--tabs {\n        border-bottom: 1px solid var(--light-grey);\n\n        // :global(.ant-tabs-nav-list) {\n        //   width: calc(100% - 1px);\n        //   background: #F4F4F5;\n        //   padding: 8px;\n        //   border-radius: 8px;\n\n        //   :global(.ant-tabs-tab) {\n        //     flex: 1;\n        //     justify-content: center;\n        //     border-radius: 4px;\n        //     background: transparent;\n        //     border: 1px solid rgba(0, 0, 0, 0.1);\n        //   }\n\n        //   :global(.ant-tabs-tab-active) {\n        //     background: white;\n        //     box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n        //   }\n        // }\n      }\n\n      // :global(.ant-tabs-top > .ant-tabs-nav::before) {\n      //   border: 1px solid red;\n      // }\n      .search-scholar-section {\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n\n        .clear-search-button {\n          width: 90px;\n          height: 35px;\n          border-radius: 50px;\n          color: var(--dark-grey);\n          background: transparent;\n          margin-left: 10px;\n        }\n\n        .clear-search-button:hover {\n          background: var(--explore-color);\n          color: white;\n          cursor: pointer;\n        }\n      }\n    }\n\n    @media only screen and (max-width: 480px) {\n      // display: none;\n    }\n  }\n\n  .tabs-mobile {\n    display: none;\n\n    @media only screen and (max-width: 480px) {\n      display: flex;\n      flex-direction: column;\n\n      :global(.ant-tabs-nav) {\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n        border-radius: 10px !important;\n        padding-left: 20px;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    width: 100%;\n  }\n}\n\n.shadow {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scholars-and-peers": `ScholarsAndPeers_scholars-and-peers__cQ1ZD`,
	"tabs-landscape": `ScholarsAndPeers_tabs-landscape__uQXNw`,
	"top-result": `ScholarsAndPeers_top-result__O1szh`,
	"top-result--tabs": `ScholarsAndPeers_top-result--tabs__KMEwj`,
	"search-scholar-section": `ScholarsAndPeers_search-scholar-section__qhl+n`,
	"clear-search-button": `ScholarsAndPeers_clear-search-button__PNIvs`,
	"tabs-mobile": `ScholarsAndPeers_tabs-mobile__VpMMI`,
	"shadow": `ScholarsAndPeers_shadow__4Rh-e`
};
export default ___CSS_LOADER_EXPORT___;
